<app-autocomplete-select
  [ngModel]="value"
  (ngModelChange)="valueChanged($event)"
  [ngModelOptions]="{ standalone: true }"
  [multiple]="multiple"
  [placeholder]="placeholder"
  [selectClass]="selectClass"
  [disabled]="disabled"
  [maxOptions]="maxOptions"
  [optionScope]="optionScope"
  [searchFn]="searchOptions"
  [preloadFn]="preloadOptions"
></app-autocomplete-select>
